/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-14 17:45:57
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2022-12-13 15:09:09
 * @FilePath: \baishu_react_ui\src\components\BsyBatchEditPane\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyWidget } from '../BsyWidget';
import BsyIconBtn from '../BsyIconBtn';
import './index.css'
import BsyDataTable from '../BsyDataTable';

export default class BsyBatchEditpPeviewPane extends BsyWidget {
    static defaultProps = {
        postData: {},
        fields: [],
    }
    constructor(props) {
        super(props);
        this.state = {
            ...props
        }
        this.element = React.createRef();
    }

    render() {
        const { formId, entryId, appId, fields, newValue, fieldName, postData, is_dock_form } = this.state;
        // let that = this;
        return (
            <div className={"bsy-batch-edit-peview-pane"} ref={this.element}>
                <div className='content-main'>
                    <div className='peview-data-formula'>
                        <div className='peview-row'><span>{postData.mode === 'formula' ? (React.language('formula') + "：") : React.language('newValue.label')}</span><span dangerouslySetInnerHTML={{ __html: newValue }}></span></div>
                    </div>

                    <div className='peview-data'>

                        <div className='peview-data-title'><span>{React.language('update.field.label')}</span><span className='widgetName'>{fieldName}</span></div>

                        <BsyDataTable
                            widgetId={'batch-peview-table'}
                            sortIncludedField={[]}
                            forms={[formId]}
                            entryId={entryId}
                            is_dock_form={postData.is_dock_form}
                            appId={appId}
                            fields={fields}
                            skip={this.skip || 0}
                            hasCount={false}
                            getContext={this.getContext}
                            url={'/data/batch_update_preview'}
                            key={this.componentKey}
                            hasAutoHeightCache={false}
                            hasRowClick={false}
                            onDataGet={(url, config, cb) => {
                                React.axios(url, {
                                    ...config,
                                    extDashData: this.state.extDashData,
                                    ...this.state.postData
                                }).then(res => {
                                    let ress = { ...res }
                                    for (let i = 0; i < ress.data.header.length; i++) {
                                        if (i === 0) {
                                            if (ress.data.header[i].type === 'subform') {
                                                ress.data.header[0].items[0].customCls = 'modifyfield'
                                                ress.data.header[0].items[1].customCls = 'orgfield'
                                            } else {
                                                ress.data.header[0].customCls = 'modifyfield'
                                                ress.data.header[1].customCls = 'orgfield'
                                            }
                                        } else if (i > 1) {
                                            ress.data.header[i].customCls = 'formulafield'
                                        }
                                    }
                                    if (ress.data.data.length > 0) {
                                        this.element.current.querySelector('.blue.edit-btn').classList.remove('bsy-ui-disable')
                                    }
                                    cb && cb(ress);
                                }
                                )
                            }}
                            onReload={() => {
                                // 切换可显示字段的时候，会引起样式BUG 需要整个div刷新 2022 06 13 波波
                                this.componentKey = 'table' + this.renderIndex++;
                                this.skip = this.componentContext.state.skip;
                                this.setState({})
                            }}
                        />
                    </div>
                    <div className="edit-footer">

                        <BsyIconBtn
                            mode={window.mode}
                            type={'edit-btn'}
                            text={React.language('cancel')}
                            click={(e) => {
                                if (this.props.onCancel) {
                                    this.props.onCancel();
                                }
                            }}
                        />
                        <BsyIconBtn
                            mode={window.mode}
                            text={React.language('modify')}
                            type={"blue edit-btn bsy-ui-disable "}
                            click={(e) => {

                                if (this.props.onOk) {
                                    this.props.onOk();
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

